import isLooselySameValue from './IsLooselySameValue';

/**
 * Compares 2 arrays to see if they contain the same values, regardless of sorting
 * @param {*} arr1
 * @param {*} arr2
 */
export default function (arr1, arr2) {
    if (typeof arr1 !== 'object' || typeof arr1 !== typeof arr2) {
        return false;
    }
    let allValuesFound = true;
    arr1.forEach((value1) => {
        if (!allValuesFound) {
            return;
        }
        let valueFoundForThisKey = false;
        arr2.forEach((value2) => {
            if (valueFoundForThisKey) {
                return;
            }
            // If the first value is an array, recursively call this array match function, otherwise just compare values
            let match = (typeof value1 == 'object') ? isSameArray(value1, value2) : isLooselySameValue(value1, value2);
            valueFoundForThisKey = (match) ? true : valueFoundForThisKey;
        });
        allValuesFound = valueFoundForThisKey;
    });
    return allValuesFound;
};